import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const NameField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.Name} field={FIELD_NAMES.NAME} optional={optional} />;
};

NameField.propTypes = {
  optional: PropTypes.bool,
};
